import IM from '@/plugins/im'
import util from '@/utils/util'

const state = {
  sdkReady: false,
  dataLoaded: false,
  unreadCount: 0,
  conversationList: [],
  selectedConversation: null,
  initChatUser: null,
  messageListMap: []
}

const mutations = {
  SET_SDK_READY: (state, payload) => {
    state.sdkReady = payload
  },
  SET_DATA_LOADED: (state, payload) => {
    state.dataLoaded = payload
  },
  SET_SDK_INSTANCE: (state, payload) => {
    state.imInstance = payload
  },
  UPDATE_UNREAD_COUNT: (state, payload) => {
    state.unreadCount = payload
  },
  UPDATE_CONVERSATION_LIST: (state, payload) => {
    // console.log('====before sort=====', payload.map(item => item.lastMessage.lastTime))
    state.conversationList = payload
      // .sort((a, b) => {
      //   return b.lastMessage.lastTime - a.lastMessage.lastTime
      // })
    // console.log('====after sort=====', payload.map(item => item.lastMessage.lastTime))
  },
  UPDATE_SELECTED_CONVERSATION: (state, payload) => {
    state.selectedConversation = payload
  },
  UPDATE_MESSAGE_LIST: (state, payload) => {
    state.messageListMap = payload
  },
  UPDATE_INIT_CHAT_USER: (state, payload) => {
    state.initChatUser = payload
  }
}

const actions = {
  setSdkReady: ({ commit }, payload) => {
    console.log('setSdkReady vuex');
    commit('SET_SDK_READY', payload ? payload.status : false)
    // commit('SET_SDK_INSTANCE', payload && payload.status ? payload.instance : false)
  },
  updateUnreadCount: ({ commit }, payload) => {
    commit('UPDATE_UNREAD_COUNT', payload)
  },
  updateConversationList: async ({ commit }, payload) => {
    const list = payload.map(item => item.userProfile.userID)
    if (location.pathname.indexOf('/chat/') === -1) {
      if (!state.dataLoaded) {
        commit('SET_DATA_LOADED', true)
      }
      commit('UPDATE_CONVERSATION_LIST', payload)
      return
    }
    // commit('UPDATE_CONVERSATION_LIST', payload)
    IM.tim.getUserProfile({
      userIDList: list
    }).then(({ data }) => {
      data.forEach((value) => {
        const index = payload.findIndex(item => item.userProfile.userID === value.userID)
        if (index !== -1) {
          payload[index].customInfo = value.profileCustomField.reduce((rs, item) => {
            rs[item.key] = item.value
            return rs
          }, {})
          payload[index].userProfile.onlineTime = util.onlineTime({
            userOnlineStatus: payload[index].customInfo.Tag_Profile_Custom_Online,
            offlineTime: payload[index].customInfo.Tag_Profile_Custom_OffTime,
            isIM: true
          })
          payload[index].userProfile.canOrder = payload[index].customInfo.Tag_Profile_Custom_CanOrder === 'WantOrder'
          payload[index].userProfile.userLevel = +payload[index].customInfo.Tag_Profile_Custom_UserLev || 0
        }
      })
      if (!state.dataLoaded) {
        commit('SET_DATA_LOADED', true)
      }
      commit('UPDATE_CONVERSATION_LIST', payload)
    })
  },
  deleteConversation: ({ state, dispatch }, conversationID) => {
    if (conversationID) {
      console.log('删除的会话：', conversationID);
      // this.lastDelChat = chatInfo;
      IM.tim.deleteConversation(conversationID).then(() => {
        const { conversationList, selectedConversation } = state
        if (selectedConversation && selectedConversation.conversationID === conversationID) {
          dispatch('selectConversation', null)
        }
        conversationList.splice(conversationList.findIndex(item => item.conversationID === conversationID), 1)
        dispatch('updateConversationList', conversationList)
      });
    }
  },
  updateMessageList: ({ commit }, payload) => {
    commit('UPDATE_MESSAGE_LIST', payload)
  },
  selectConversation: ({ commit, state, rootState }, conversation) => {
    if (state.selectedConversation && conversation && state.selectedConversation.userProfile.userID === conversation.userProfile.userID) return Promise.resolve()

    return new Promise(resolve => {
      commit('UPDATE_SELECTED_CONVERSATION', conversation)

      if (!conversation || !conversation.conversationID) {
        commit('UPDATE_MESSAGE_LIST', [])
        return
      }

      commit('UPDATE_MESSAGE_LIST', [
        {
          isLoading: true,
          avatar: conversation.userProfile.avatar,
        }
      ])

      IM.tim.setMessageRead({conversationID: conversation.conversationID})

      let result = []
      
      const getMessage = async (nextReqMessageID = null) => {
        try {
          const { data } = await IM.tim.getMessageList({ conversationID: conversation.conversationID, nextReqMessageID })

          result = [
            ...data.messageList,
            ...result
          ]

          if (data.isCompleted || result.length >= 150) {
            renderMessage()
          } else {
            getMessage(data.nextReqMessageID)
          }
        } catch(e) {
          renderMessage()
        }
      }

      const renderMessage = () => {
        const list = result.map(({ type, time, payload, from }) => {
          const isSelf = from === rootState.app.userInfo.uuid

          return {
            avatar: isSelf ? rootState.app.userInfo.avatarUrl : conversation.userProfile.avatar,
            fromUuid: from,
            time: time,
            payload,
            isSelf,
            type
          }
        })
        if (conversation.userProfile.userID === state.selectedConversation.userProfile.userID) {
          commit('UPDATE_MESSAGE_LIST', list)
        }

        resolve()
      }

      getMessage()
    })
  },
  sendMessage: ({ commit, state, rootState }, payload) => {
    return new Promise((resolve, reject) => {
      IM.tim.sendMessage(payload).then(({ data }) => {
        const list = state.messageListMap

        // if (data.message.type === IM.TYPES.MSG_TEXT) {
          list.push({
            payload: data.message.payload,
            type: data.message.type,
            avatar: rootState.app.userInfo.avatarUrl,
            isSelf: true,
            fromUuid: rootState.app.userInfo.uuid,
            time: data.message.time
          })
          commit('UPDATE_MESSAGE_LIST', list)
        // }

        resolve(data)
      }).catch(({ data, code } )=> {
        if (parseInt(code) === 80001 && data.message.type === IM.TYPES.MSG_TEXT){
          const list = state.messageListMap
          list.push({
            payload: data.message.payload,
            type: data.message.type,
            avatar: rootState.app.userInfo.avatarUrl,
            isSelf: true,
            fromUuid: rootState.app.userInfo.uuid,
            time: data.message.time,
            isSensitive: true
          })
          commit('UPDATE_MESSAGE_LIST', list)
          reject(code)
        } else if(parseInt(code) === 20007) {
          reject(code)
        }
      })
    })
  },
  setCurrentChatUser: ({ dispatch, commit, state }, payload) => {
    return new Promise(resolve => {
      Promise.all([
        IM.tim.getUserProfile({
          userIDList: [ payload ]
        }),
        IM.tim.getConversationList()
      ]).then(resp => {
        const userInfo = resp[0].data && resp[0].data[0] ? resp[0].data[0] : null
        const conversationList = resp[1].data ? resp[1].data.conversationList : null
        if (userInfo) {
          const user = {
            userProfile: {
              userID: userInfo.userID,
              avatar: userInfo.avatar,
              nick: userInfo.nick,
              profileCustomField: userInfo.profileCustomField,
            },
            lastMessage: {
              payload: {}
            }
          }

          if (conversationList.length) {
            const index = conversationList.findIndex(chat => chat.userProfile.userID === userInfo.userID)

            if (index > -1) {
              commit('UPDATE_INIT_CHAT_USER', conversationList[index])
              dispatch('selectConversation', conversationList[index])

              return resolve()
            }
          }

          state.conversationList.unshift(user)

          commit('UPDATE_INIT_CHAT_USER', user)
          commit('UPDATE_CONVERSATION_LIST', state.conversationList)
          dispatch('selectConversation', user)

          resolve()
        }
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}